export default __webpack_public_path__ + "static/media/bobbleHigh.e0fe251e.svg";